import { createFileRoute } from "@tanstack/react-router";
import { FaqSection } from "@/components/faq-section";
import { PricingTable } from "@/components/pricing-table";
import { PublicFooter, PublicHeader } from "@/components/public-layout";
import { buildPricingJsonLd, JsonLd } from "@/lib/json-ld";
import {
	buildLocalizedSeoLinks,
	getLocalizedSeoUrls,
	ogImageUrl,
} from "@/lib/seo";

export const Route = createFileRoute("/pricing")({
	component: Pricing,
	head: ({ matches }) => {
		const seoUrls = getLocalizedSeoUrls({
			matches,
			internalPath: "/pricing",
		});

		return {
			meta: [
				{
					title: "AgentReacher | Pricing",
				},
				{
					name: "description",
					content:
						"Connect your AI workflow to social publishing. Compare AgentReacher plans for connected accounts, scheduling, publishing, and support.",
				},
				{
					property: "og:title",
					content: "AgentReacher | Pricing",
				},
				{
					property: "og:description",
					content:
						"Compare the AgentReacher plans built around connected accounts, scheduling, and scale.",
				},
				{
					property: "og:image",
					content: ogImageUrl("pricing"),
				},
				{ property: "og:url", content: seoUrls.canonicalUrl },
				{ name: "twitter:card", content: "summary_large_image" },
				{ name: "twitter:image", content: ogImageUrl("pricing") },
			],
			links: buildLocalizedSeoLinks({
				matches,
				internalPath: "/pricing",
			}),
		};
	},
});

export function Pricing() {
	return (
		<div className="flex min-h-svh flex-col bg-background text-foreground">
			<JsonLd data={buildPricingJsonLd()} />
			<PublicHeader />

			<main className="relative z-10 flex-1">
				<div className="mx-auto max-w-6xl px-4 sm:px-6">
					<div className="marketing-line-stack flex flex-col overflow-hidden divide-y divide-border">
						<section className="rounded-md bg-white dark:bg-black px-6 py-10 text-center sm:px-10 sm:py-14">
							<h1 className="text-3xl font-semibold tracking-[-0.04em] sm:text-4xl">
								Find the right plan for your needs.
							</h1>
							<p className="mx-auto mt-3 max-w-2xl text-sm text-muted-foreground sm:text-base">
								Whether you're an individual content creator, a brand, a
								business, or an agency, we've got you covered.
							</p>
						</section>

						<PricingTable />

						<FaqSection />
					</div>
				</div>
			</main>

			<PublicFooter />
		</div>
	);
}
